import { useEffect, useState } from 'react'

const DAY_MS = 24 * 60 * 60 * 1000
const STORAGE_KEY = 'biblioteca-salomon:deadline'

function readDeadline(): number {
  if (typeof window === 'undefined') return Date.now() + DAY_MS

  const stored = window.localStorage.getItem(STORAGE_KEY)
  const parsed = stored ? Number(stored) : NaN

  if (Number.isFinite(parsed) && parsed > Date.now()) return parsed

  const next = Date.now() + DAY_MS
  window.localStorage.setItem(STORAGE_KEY, String(next))
  return next
}

function format(value: number): string {
  return String(Math.max(0, value)).padStart(2, '0')
}

export interface Countdown {
  hours: string
  minutes: string
  seconds: string
}

/** Cuenta regresiva de 24 horas que se reinicia cuando expira. */
export function useCountdown(): Countdown {
  const [deadline, setDeadline] = useState(readDeadline)
  const [remaining, setRemaining] = useState(() => deadline - Date.now())

  useEffect(() => {
    const id = window.setInterval(() => {
      const left = deadline - Date.now()

      if (left <= 0) {
        const next = Date.now() + DAY_MS
        window.localStorage.setItem(STORAGE_KEY, String(next))
        setDeadline(next)
        setRemaining(DAY_MS)
        return
      }

      setRemaining(left)
    }, 1000)

    return () => window.clearInterval(id)
  }, [deadline])

  const totalSeconds = Math.floor(remaining / 1000)

  return {
    hours: format(Math.floor(totalSeconds / 3600)),
    minutes: format(Math.floor((totalSeconds % 3600) / 60)),
    seconds: format(totalSeconds % 60),
  }
}
